import { useFormContext } from 'react-hook-form'
import { useDateFormat, useFeatureFlags } from '../../../../../hooks'
import { Calendar } from '../../../../forms'
import { isAfter, startOfMonth } from 'date-fns'
import { ReservationFormData } from '../constants'
import { MergedAvailabilities } from '../../../../../types/mergedAvailabilities'
import { getEarliestBusinessDate } from '../../../../../util/skipBusinessDays'
import { CustomPickersDay } from 'components/CustomPickersDay'
import { PickersDayProps } from '@mui/lab'

interface Props {
  availabilities: MergedAvailabilities
}

const Day = ({ availabilities }: Props) => {
  const { setValue, watch } = useFormContext<ReservationFormData>()
  const [customerTimeZone] = watch(['timezone'])
  const { dateToISODateKey } = useDateFormat()
  const [shouldSkipTwoBusinessDaysFeatureFlag] = useFeatureFlags<boolean>(['SKIP_48_BUSINESS_HOURS_ON_RESERVATIONS'])

  const onMonthChange = (date: Date | null) => {
    const currentDate = new Date()
    const firstDayOfMonth = startOfMonth(date ?? currentDate)
    const nearestPossibleDate = shouldSkipTwoBusinessDaysFeatureFlag ? getEarliestBusinessDate() : currentDate
    const dateStart = isAfter(nearestPossibleDate, firstDayOfMonth) ? nearestPossibleDate : firstDayOfMonth

    setValue('dateStart', dateStart)
    setValue('clientStartDate', dateStart)
  }

  const renderDay = (date: Date, _: Date[], pickersDayProps: PickersDayProps<unknown>) => {
    const dateKey = dateToISODateKey(date)

    const isDisabled = pickersDayProps.disabled || (shouldSkipTwoBusinessDaysFeatureFlag && date < getEarliestBusinessDate())
    if (isDisabled) return <CustomPickersDay {...pickersDayProps} dayState={'DISABLED'} />

    const noAvailabilityForDate = !availabilities || Object.keys(availabilities).length === 0 || !availabilities[dateKey]
    if (noAvailabilityForDate) return <CustomPickersDay {...pickersDayProps} dayState={'NOT_AVAILABLE'} />

    const isPartialDay = availabilities[dateKey].length === 0
    if (isPartialDay) return <CustomPickersDay {...pickersDayProps} dayState={'PARTIAL'} />

    return <CustomPickersDay {...pickersDayProps} dayState={'AVAILABLE'} />
  }

  return <Calendar customerTimeZone={customerTimeZone} name="clientStartDate" onMonthChange={onMonthChange} renderDay={renderDay} />
}

export { Day }
